import { setSafe } from "../../../util/storeHelper";
import * as actions from "../actions";
const sessionReducer = {
    reducers: {
        [actions.setAnnouncements]: (state, payload) => setSafe(state, ["announcements"], payload),
    },
    defaults: {
        announcements: [],
    },
};
export default sessionReducer;
